import React, {Component} from 'react';
import { push } from 'redux-little-router';
import { connect } from '~/redux/connect';
import {
    getColumns,
    getDataActionPermissions, getDirectColumnVisibility,
    getSearchModel, getSearchResultSort, getTooltipsActive
} from "~/stateGetter";
import {modelActionsCreator} from "~/actions/model_actions";
import toOrderedArray from "~/lib/toOrderedArray";
import {compareKeys} from "mythil/object";
import ResultTable from "~/ui/components/ResultTable/ResultTable";
import {presentColumns} from "~/statePresenter";
import {setActiveAppBarDialog} from "~/actions/ui_actions";
import { settingsActionCreator } from '~/actions/settingsActions';
import css from "./css";

class _ModelResultTable extends Component  {
    viewEntry = (entry) => {
        this.props.closeDialog();
        return this.props.push(`/${this.props.modelName}/${entry.id.raw}/view`, { forceChangeRootModel: true })
    };

    editEntry = (entry) => {
        let { update, modelName } = this.props;

        if(!update) { return this.viewEntry(entry); }

        this.props.closeDialog();
        return this.props.push(`/${modelName}/${entry.id.raw}/edit`, { forceChangeRootModel: true });
    };
    
    render() {
        return <ResultTable
            tableContainerClassName={css.searchTableContainer}
            viewEntry={this.viewEntry}
            editEntry={this.props.update ? this.editEntry : null}
            {...this.props}
        />
    }
}

const _areStatePropsEqual = (prev, curr) => {
    return compareKeys(prev, curr);
};

const areStatePropsEqual = (prev, curr) => {
    let isEqual  = _areStatePropsEqual(prev, curr);

    if(!isEqual) {
        // console.log('ModelResultTable areStatePropsEqual PERF', diffKeys(prev, curr));
    }

    return isEqual;
};


const ModelResultTable = connect((state, {modelName}) => {
    let searchModel = getSearchModel(state, modelName);
    
    return {
        tableSettingsIdentifier: modelName,
        sortOptions: getSearchResultSort(state, modelName),
        perPage: searchModel.resultParams.perPage,
        resultValue: searchModel.results.value,
        columns: getColumns(state, modelName),
        columnVisibility: getDirectColumnVisibility(state, modelName),
        tooltipsActive: getTooltipsActive(state),
        ...getDataActionPermissions(state, modelName),
    }
}, (dispatch, {modelName}) => {
    let modelActions = modelActionsCreator(modelName),
        settingActions = settingsActionCreator(modelName);


    return {
        closeDialog: () => dispatch(setActiveAppBarDialog(null)),
        changeSort: (sort) => dispatch(settingActions.changeSort(sort)),
        onRowSelect: (value) => dispatch(modelActions.updateSelectedRows(value)),
        push: (...args) => dispatch(push(...args)),
    }
}, ({resultValue, ...props}, dispatchProps, {filterResultsValue, ...ownProps}) => {
    
    resultValue = filterResultsValue ? filterResultsValue(resultValue) : resultValue;
    resultValue = {
        ...resultValue,
        results: toOrderedArray(resultValue.results)
    };

    return {
        ...ownProps,
        ...dispatchProps,
        ...props,
        resultValue,
        visibleColumns: presentColumns(props).filter(c => !c.hidden)
    }
}, {})(_ModelResultTable);

export default ModelResultTable;